import React, { useEffect, useState } from "react";
import { FaBell, FaUserCircle, FaMoon, FaSun, FaBars } from "react-icons/fa";
import "./Navbar.css"; // Custom CSS file for styling
import { Link, useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios to make HTTP requests

const Navbar = ({ darkMode, toggleDarkMode, toggleSidebar }) => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [profileData, setProfileData] = useState([]);

  const [showNotifications, setShowNotifications] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0); // To store unread notifications count
  const navigate = useNavigate();
  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const closeProfileMenu = () => {
    setIsProfileMenuOpen(false);
  };

  // Fetch notifications from the server
  const fetchNotifications = async () => {
    try {
      // Fetch user details
      const meResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/staff/me`,
        {
          withCredentials: true,
        }
      );

      if (!meResponse.data.success) {
        throw new Error("Failed to get user details");
      }

      const { id } = meResponse.data;

      if (!id) {
        console.error("Invalid token: id not found");
        return;
      }
      const responsecso = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/staff/staff/${id}`,
        {
          withCredentials: true,
        }
      );

      const data = responsecso.data;
      setProfileData(data);
      // Fetch notifications using Axios
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/notifications`,
        {
          withCredentials: true, // If your API requires credentials
        }
      );

      // Assuming the response data is an array of notifications
      const notificationsData = response.data;

      // console.log("Notifications Data:", notificationsData);

      // if (!Array.isArray(notificationsData)) {
      //   console.error("Notifications data is not an array", notificationsData);
      //   return;
      // }

      // Convert id to string for comparison with author_id
      const normalizedId = String(id);

      // Filter notifications where the author is not the logged-in user
      const filteredNotifications = notificationsData.filter((notif) => {
        // Ensure author_id is treated as a string during comparison
        return String(notif.author_id) !== normalizedId;
      });

      // Log the filtered notifications for debugging
      // console.log("Filtered Notifications:", filteredNotifications);

      // Update the state with filtered notifications
      setNotifications(filteredNotifications);

      // Calculate the number of unread notifications
      const unread = filteredNotifications.filter(
        (notif) => !notif.read
      ).length;
      setUnreadCount(unread);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const notificationWrapper = document.querySelector(
        ".notification-wrapper"
      );
      if (notificationWrapper && !notificationWrapper.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // Toggle the notification dropdown
  const toggleNotificationDropdown = () => {
    setShowNotifications(!showNotifications);
  };

  // Mark a notification as read
  const markAsRead = async (id) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/notifications/read/${id}`
      );
      fetchNotifications(); // Refresh the notification list
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/staff/logout`,
        {},
        {
          withCredentials: true,
        }
      );
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      window.location.href = "/login";
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const viewReportDetails = async (report_id) => {
    try {
      // navigate(`/admin/show_report/${report_id}`);
      navigate(`/admin/view_submission/${report_id}`);
    } catch (error) {
      console.error("Error fetching report details:", error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <FaBars className="hamburger-icon" />
        </button>
      </div>

      {/* <div className="navbar-center">
        <div className="search-bar p-7 flex items-center border rounded-full px-1 py-1 w-full max-w-md border-gray-300 focus-within:border-blue-500">
          <FaSearch className="text-gray-400 text-lg m-2" />
          <input
            type="text"
            placeholder="Search"
            className="px-2 py-1 mr-1 mb-1 rounded-full border text-black border-gray-300 focus:outline-none focus:border-none text-sm w-full"
          />
        </div>
      </div> */}
      <div className="navbar-right">
        <h6 className="p-2 bg-gray-50 rounded-lg whitespace-nowrap overflow-hidden text-ellipsis max-w-[100px] sm:max-w-none">
          Hello, {profileData.name}
        </h6>

        <button className="dark-mode-toggle" onClick={toggleDarkMode}>
          {darkMode ? <FaSun /> : <FaMoon />}
        </button>
        <div className="notification-wrapper">
          <FaBell
            className="icon"
            onClick={toggleNotificationDropdown}
            title="View Notifications"
          />
          {unreadCount > 0 && (
            <span className="notification-count">{unreadCount}</span> // Show unread notification count
          )}
          {showNotifications && (
            <div className="notifications-dropdown">
              {notifications.filter((notif) => !notif.read).length > 0 ? (
                <ul>
                  {notifications
                    .filter((notif) => !notif.read) // Show only unread notifications
                    .map((notif) => (
                      <li key={notif.id} className="unread">
                        {notif.notification_message}
                        <p>{new Date(notif.timestamp).toLocaleString()}</p>
                        <button
                          onClick={() => {
                            viewReportDetails(notif.report_id);
                            markAsRead(notif.id);
                            // setShowNotifications(false); // Add this line to close dropdown
                          }}
                          className="px-2 py-0 bg-green-600 rounded text-white text-sm"
                        >
                          View
                        </button>
                      </li>
                    ))}
                </ul>
              ) : (
                <p>No unread notifications</p>
              )}
            </div>
          )}
        </div>
        <div className="profile-menu">
          <FaUserCircle
            className="icon user-icon"
            onClick={toggleProfileMenu}
          />
          {isProfileMenuOpen && (
            <div className="dropdown-menu" onMouseLeave={closeProfileMenu}>
              <ul>
                <li onClick={closeProfileMenu}>
                  <Link to="/admin/view_profile">Profile</Link>
                </li>
                <li onClick={closeProfileMenu}>
                  <Link to="/admin/update_password">Update Password</Link>
                </li>
                <li onClick={handleLogout}>Log Out</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
